import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { LanguageService } from '../../../shared/services/language/language.service';
import { FormButton } from '../../../shared/models/form-button';

export interface LanguageSwitcherDialogData {
    locale: string;
    label: string;
}

@Component({
    selector: 'app-language-switcher-confirm-dialog',
    templateUrl: './language-switcher-confirm-dialog.component.html',
})
export class LanguageSwitcherConfirmDialogComponent {
    form: FormGroup = this.fb.group({});

    save: FormButton = {
        text: 'languageSwitcher.confirm',
        theme: 'raised',
        color: 'primary',
        type: 'button',
        condition: () => true,
		disabled: () => false,
        click: () => this.confirm(),
    };

    reset: FormButton = {
        text: 'languageSwitcher.cancel',
        condition: () => true,
        click: () => this.cancel(),
    };

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: LanguageSwitcherDialogData,
        private dialogRef: MatDialogRef<LanguageSwitcherConfirmDialogComponent>,
        private languageService: LanguageService,
        private fb: FormBuilder
    ) {}

    confirm(): void {
        this.languageService.saveLocale(this.data.locale);
        this.dialogRef.close();
        window.location.reload();
    }

    cancel(): void {
        this.dialogRef.close();
    }
}
